import { makeDeleteApiCall, makeGetApiCall, makePatchApiCall, makePostApiCall } from "./makeApiCall";
import type { ApiMessage } from "../types/api";
import type {
  CreatedShipment, InvoiceResponse, OrderShipmentSummary, SaveShipmentPayload,
  Shipment, ShipmentDraft, ShipmentDraftSummary, ShipmentOrder, ShipmentOrderSummary, ShipmentsResponse,
  ShipmentStatus, ShipmentStatusResponse,
} from "../types/shipping";

export const shippingApi = {
  orders: () => makeGetApiCall<{ orders: ShipmentOrderSummary[] }>("/mobile/shipments/orders"),
  order: (id: number | string) => makeGetApiCall<ShipmentOrder>(`/mobile/shipments/orders/${id}`),
  orderShipments: (id: number | string) =>
    makeGetApiCall<{ shipments: OrderShipmentSummary[] }>(`/orders/${id}/shipments`),
  history: () => makeGetApiCall<{ shipments: Shipment[] }>("/mobile/shipments/history"),
  shipment: (id: number | string) => makeGetApiCall<Shipment>(`/mobile/shipments/${id}?lifecycle=1`),
  updateShipment: (id: number | string, payload: Partial<Pick<Shipment, "invoice_number" | "seal_number" | "notes">>) =>
    makePatchApiCall<ApiMessage, typeof payload>(`/mobile/shipments/${id}`, payload),
  shipments: (search = "", status: ShipmentStatus | "" = "", page = 1) =>
    makeGetApiCall<ShipmentsResponse>(`/shipments?search=${encodeURIComponent(search)}&status=${encodeURIComponent(status)}&page=${page}`),
  create: (payload: SaveShipmentPayload) => makePostApiCall<CreatedShipment, SaveShipmentPayload>("/mobile/shipments", payload),
  correctItem: (shipmentId: number | string, itemId: number | string, quantity: number) =>
    makePostApiCall<ApiMessage, { quantity: number }>(`/mobile/shipments/${shipmentId}/items/${itemId}`, { quantity }),
  voidShipment: (id: number | string) => makePostApiCall<ApiMessage>(`/mobile/shipments/${id}/void`, {}),
  updateStatus: (id: number | string, status: ShipmentStatus) =>
    makePostApiCall<ShipmentStatusResponse, { status: ShipmentStatus }>(`/mobile/shipments/${id}/status`, { status }),
  drafts: () => makeGetApiCall<{ drafts: ShipmentDraftSummary[] }>("/mobile/shipment-drafts"),
  draft: (id: number | string) => makeGetApiCall<ShipmentDraft>(`/mobile/shipment-drafts/${id}`),
  saveDraft: (payload: SaveShipmentPayload) => makePostApiCall<CreatedShipment, SaveShipmentPayload>("/mobile/shipment-drafts", payload),
  finalizeDraft: (id: number | string) => makePostApiCall<CreatedShipment>(`/mobile/shipment-drafts/${id}/finalize`, {}),
  deleteDraft: (id: number | string) => makeDeleteApiCall<ApiMessage>(`/mobile/shipment-drafts/${id}`),
  createInvoice: (orderId: number | string) => makePostApiCall<InvoiceResponse>(`/createInvoice/${orderId}`, {}),
};
